import client from "@/api";
import store from "@/store";
import { _rotaIntegrations } from "@/api/_caminhosApi";

export function listIntegrations() {
  store.commit("interacoes/SET_LOADING", true);
  store.commit("integrations/SET_INTEGRATIONS", null);
  client
    .get(`${_rotaIntegrations()}`)
    .then(resp => {
      if (resp.status === 200 && resp.data.integrations.length > 0) {
        store.commit("integrations/SET_INTEGRATIONS", resp.data.integrations);
      } else {
        store.commit("integrations/SET_INTEGRATIONS", []);
      }
    })
    .catch(erro => {
      console.log(erro);
    })
    .then(() => {
      store.commit("interacoes/SET_LOADING", false);
    });
}

export function verifyGoogleAds() {
  client
    .get(`${_rotaIntegrations()}/googleads/verify`)
    .then(resp => {
      console.log('verifyGoogleAds resp', resp)
      store.commit("integrations/SET_GOOGLE_ADS_CONNECTED", resp.data);
      return resp;
    })
    .catch(erro => {
      console.log(erro);
    })
    .then(() => {
    });
}

export function connectGoogleAds() {
  store.commit("interacoes/SET_LOADING", true);
  client
    .post(`${_rotaIntegrations()}/googleads/connect`)
    .then(resp => {
      console.log('connectGoogleAds resp', resp)
      store.commit("integrations/SET_GOOGLE_ADS", resp.data);
      return resp;
    })
    .catch(erro => {
      console.log(erro);
    })
    .then(() => {
      store.commit("interacoes/SET_LOADING", false);
    });
}

export function getGoogleAdsAccounts() {
  store.commit("interacoes/SET_LOADING", true);
  client
    .get(`${_rotaIntegrations()}/googleads/accounts`)
    .then(resp => {
      console.log('getGoogleAdsAccounts resp', resp)
      store.commit("integrations/SET_GOOGLE_ADS_ACCOUNTS", resp.data);
      return resp.data;
    })
    .catch(erro => {
      console.log(erro);
    })
    .then(() => {
      store.commit("interacoes/SET_LOADING", false);
    });
}

export function selectGoogleAdsAccount(customerId) {
  store.commit("interacoes/SET_LOADING", true);
  client
    .post(`${_rotaIntegrations()}/googleads/accounts`, {
      customer_id: customerId
    })
    .then(resp => {
      console.log('selectGoogleAdsAccount resp', resp)
      listIntegrations();
      return resp;
    })
    .catch(erro => {
      console.log(erro);
    })
    .then(() => {
      store.commit("interacoes/SET_LOADING", false);
    });
}